(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-pdp-info-top-row"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bmPdpInfoTopRowBound) return;
    window.__bmPdpInfoTopRowBound = true;

    // Resolve a Shopify section wrapper id by suffix — Shopify wraps every section in
    // `shopify-section-<template_suffix>__<section_block_id>`, where the template suffix changes
    // per theme so we can't hard-code it. Match the trailing `__<suffix>` instead.
    function resolveBySuffix(suffix) {
      if (!suffix) return null;
      var sections = document.querySelectorAll('[id^="shopify-section-"]');
      var needle = '__' + suffix;
      for (var i = 0; i < sections.length; i++) {
        var id = sections[i].id || '';
        if (id === 'shopify-section-' + suffix || id.indexOf(needle) !== -1) {
          return sections[i];
        }
      }
      return null;
    }

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[data-bm-smooth-anchor]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var suffix = a.getAttribute('data-bm-smooth-anchor-suffix') || '';
      var target = null;
      if (href.charAt(0) === '#' && href.length > 1) {
        try { target = document.querySelector(href); } catch (err) { /* invalid selector */ }
      }
      if (!target) target = resolveBySuffix(suffix);
      if (!target) return;
      e.preventDefault();
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (err) {
        target.scrollIntoView();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
